import Analytics from "analytics";

// Custom plugin for Plausible Analytics
const plausiblePlugin = {
  name: "plausible",
  config: {
    domain: "forgecode.dev",
  },
  initialize: ({ config }: { config: { domain: string } }) => {
    // Plausible is already loaded via script tag in HTML
    console.log("Plausible Analytics initialized for domain:", config.domain);
  },
  page: ({ payload }: { payload: any }) => {
    if (typeof window !== "undefined" && window.plausible) {
      window.plausible("pageview", {
        props: payload.properties || {},
      });
    }
  },
  track: ({ payload }: { payload: any }) => {
    if (typeof window !== "undefined" && window.plausible) {
      const { event, properties } = payload;

      // Handle conversion events specially
      if (properties?.conversion) {
        window.plausible(event, {
          props: properties,
        });
      } else {
        window.plausible(event, {
          props: properties,
        });
      }
    }
  },
  identify: ({ payload }: { payload: any }) => {
    // Plausible doesn't support user identification
    // But we can use this for other providers like reb2b
    if (typeof window !== "undefined" && window.reb2b) {
      window.reb2b.identify({
        email: payload.traits?.email,
        firstName: payload.traits?.firstName,
        lastName: payload.traits?.lastName,
        createdAt: payload.traits?.createdAt,
      });
    }
  },
};

// Custom plugin for Snitcher
const snitcherPlugin = {
  name: "snitcher",
  config: {
    siteId: "8432087",
  },
  initialize: ({ config }: { config: { siteId: string } }) => {
    console.log("Snitcher initialized for site:", config.siteId);
  },
  page: () => {
    // Snitcher automatically tracks pageviews via script tag
  },
  track: () => {
    // Snitcher primarily tracks pageviews and visitor identification
    // Custom events can be sent if needed
  },
};

// Custom plugin for reb2b
const reb2bPlugin = {
  name: "reb2b",
  config: {
    key: "0OV0VHL3P56Z",
  },
  initialize: ({ config }: { config: { key: string } }) => {
    console.log("Reb2b initialized with key:", config.key);
  },
  page: () => {
    // Reb2b automatically tracks pageviews via script tag
  },
  track: ({ payload }: { payload: any }) => {
    // Track custom events with reb2b if needed - but reb2b doesn't have a track method
    console.log("Reb2b track event:", payload.event, payload.properties);
  },
  identify: ({ payload }: { payload: any }) => {
    if (typeof window !== "undefined" && window.reb2b) {
      window.reb2b.identify({
        email: payload.traits?.email,
        firstName: payload.traits?.firstName,
        lastName: payload.traits?.lastName,
        createdAt: payload.traits?.createdAt,
        userId: payload.userId,
      });
    }
  },
};

// Initialize analytics with all providers
const analytics = Analytics({
  app: "forge-frontend",
  version: "1.0.0",
  debug: process.env.NODE_ENV === "development",
  plugins: [plausiblePlugin, snitcherPlugin, reb2bPlugin],
});

// Export analytics instance and convenience functions
export default analytics;

// Convenience functions for common tracking events
export const trackSignup = (
  method: "github" | "google",
  isNewUser: boolean,
) => {
  if (isNewUser) {
    analytics.track("signup", {
      method,
      conversion: true,
      event_type: "conversion",
    });
  }

  analytics.track("auth_success", {
    method,
    is_new_user: isNewUser,
    event_type: isNewUser ? "conversion" : "engagement",
  });
};

export const trackAuthAttempt = (method: "github" | "google") => {
  analytics.track("auth_attempt", {
    method,
    event_type: "engagement",
  });
};

export const trackDashboardAccess = () => {
  analytics.track("dashboard_access", {
    event_type: "engagement",
  });
};

export const trackApiKeyCreated = () => {
  analytics.track("api_key_created", {
    conversion: true,
    event_type: "conversion",
  });
};

export const identifyUser = (user: {
  id: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  createdAt?: string;
}) => {
  analytics.identify(user.id, {
    email: user.email,
    firstName: user.firstName,
    lastName: user.lastName,
    createdAt: user.createdAt,
  });
};

// Export the analytics instance for direct use
export { analytics };
